import React, { useEffect, useContext, useState, useActionState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Context_UI } from '../../Contexts/Context_UI';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useAccounts } from '../../Contexts/Context_Accounts';

import UI_Card from '../ERUMAUI/UI_Card';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import Icon_Calendar_NoUpcoming from '../../Assets/Icons/Icon_Color_Reserved.png';


export default function List_Timeline({ Data }) {
    const UI = useContext(Context_UI);
    const { User_Permission } = useAccounts();
    const { Status_Parse, Time_Parse, Time_Range_Parse, Schedules, Schedule_Display, Schedule_Information } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();

    const Now = new Date();
    Now.setHours(0, 0, 0, 0);
    const [Schedules_Grouped, Schedules_Grouped_Set] = useState([]);

    const Navigate = useNavigate();
    useEffect(() => {
        const Schedules_Group = (schedules) => {
            const Grouped = {};
            if (schedules && schedules.length > 0) {
                schedules.forEach(schedule => {
                    const date = new Date(schedule.Time.Start).toISOString().split('T')[0];
                    const room = schedule.RoomID;

                    if (!Grouped[date]) {
                        Grouped[date] = {};
                    }

                    if (!Grouped[date][room]) {
                        Grouped[date][room] = [];
                    }

                    Grouped[date][room].push(schedule);
                });
            }


            return Object.entries(Grouped).map(([date, rooms]) => ({
                Date: new Date(date),
                Rooms: Object.entries(rooms).map(([roomID, schedules]) => ({
                    RoomID: roomID,
                    Schedules: schedules
                }))
            }));
        }
        Schedules_Grouped_Set(Schedules_Group(Schedules).sort((a, b) => new Date(a.Date) - new Date(b.Date)));
    }, [Schedules]);

    // useEffect(() => {
    //     console.log(Schedules_Grouped);
    // }, [Schedules_Grouped])

    const Handle_Click = (ID) => {
        Schedule_Display(ID);
        Navigate("/schedules")
    }

    return (
        <>

            <div className='SM_Activities' View="Timeline">
                <UI_UpdatingStatus
                    State={Schedules_Grouped.length > 0 ? "Good" : "Bad"}
                    Good={{
                        Type: "Custom",
                        Content: (
                            <>
                                {Schedules_Grouped.map((Day) => (
                                    <>
                                        {
                                            Day.Date >= Now ?
                                                <div className='SM_Activities_Group'>
                                                    <div className='SM_Activities_Title'>
                                                        <h2 className='General_Paragraph' style={{ fontWeight: "50" }}>
                                                            {Time_Parse(Day.Date, "Date")}
                                                        </h2>
                                                    </div>
                                                    <div className='SM_Activities_List General_Grid' View="Grid">
                                                        {Day.Rooms.map((Room) => (
                                                            <div className='SM_Activities_List_Group'>
                                                                <UI_Divider Text={`${Room_Get_Address(Room.RoomID, "Floor")}, ${Room_Get_Address(Room.RoomID, "Room")}`} />
                                                                <div className='SM_Activities_List_Content'>
                                                                    {Room.Schedules.map((Schedule) => (
                                                                        <UI_Card
                                                                            Type="Schedule_List"
                                                                            Figure={
                                                                                {
                                                                                    Title: Schedule.Name,
                                                                                    Main: Time_Range_Parse(Schedule.Time.Start, Schedule.Time.End),
                                                                                    Chip: Status_Parse(Schedule)
                                                                                }
                                                                            }
                                                                            Subtype={Schedule._id === Schedule_Information?._id ? "Selected" : ""}
                                                                            onClick={() => Handle_Click(Schedule._id)}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                :
                                                ""
                                        }
                                    </>


                                ))}
                            </>
                        )
                    }}
                    Bad={{
                        Type: "Default",
                        Icon: Icon_Calendar_NoUpcoming,
                        Text: "No activities for now."
                    }}
                />
                
            </div>


        </>

    );
}
